// Auto generated file, do not manually modify!
// com.hotpads.dragnet.client.DragnetJsExceptionCategory

export enum DragnetJsExceptionCategory {
  BOUNDARY_BROWSER_ERROR = 'BOUNDARY_BROWSER_ERROR',
  BROWSER_ERROR = 'BROWSER_ERROR',
  BROWSER_HTTP_ERROR = 'BROWSER_HTTP_ERROR',
  NODE_ERROR = 'NODE_ERROR',
  NODE_HTTP_REQUEST = 'NODE_HTTP_REQUEST',
}

export const DragnetJsExceptionCategory_values = [
  DragnetJsExceptionCategory.BOUNDARY_BROWSER_ERROR,
  DragnetJsExceptionCategory.BROWSER_ERROR,
  DragnetJsExceptionCategory.BROWSER_HTTP_ERROR,
  DragnetJsExceptionCategory.NODE_ERROR,
  DragnetJsExceptionCategory.NODE_HTTP_REQUEST,
] as const;
